// @flow

const MOBILE_ITEM_HEIGHT = 'auto';
const TILE_ACTION_BTN_WIDTH = 28;
const TABLE_MIN_WIDTH = 800;
const rowShadowAtRest = '0px 2px 8px -1px rgba(0,0,0,0.2)';
const ROW_SPACING = 0.5;
const ROW_CELL_BACKGROUND_COLOR = 'hsl(0,0%,97%)';

const commonListTableStyles = {
  tableContent: (theme) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    width: '100%',
    minWidth: TABLE_MIN_WIDTH,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),  // 12px padding on mobile
      minWidth: 'auto'
    }
  }),

  table: (theme) => ({
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: 0,
    padding: 0,
    width: '100%',
    display: 'block',
    whiteSpace: 'nowrap'
  }),

  feedTableBody: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: `calc(100vw - ${theme.layout.customProps.drawer.width}px - ${theme.spacing(6)}px)`,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      width: `calc(100vw - ${theme.layout.customProps.drawer.width}px - ${theme.spacing(6)}px)`,
      minWidth: '100%'
    }
  }),

  feedTableHeadRow: (theme) => ({
    display: 'flex',
    position: 'relative',
    // height: 30,
    marginBottom: theme.spacing(1),
    '& > th': {
      fontSize: '0.9rem',
      fontWeight: 600,
      borderBottom: 0,
      backgroundColor: 'transparent'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      position: 'relative',
      height: 30,
      marginBottom: theme.spacing(1),
      '& > th': {
        fontSize: '0.9rem',
        fontWeight: 600,
        padding: theme.spacing(1),
        borderBottom: 0,
        backgroundColor: 'transparent'
      }
    }
  }),

  cursorPointer: (theme) => ({
    cursor: 'pointer'
  }),

  textOverflow: (theme) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),

  hoverOpacity: (theme) => ({
    opacity: 0.2,
    '&.hover': {
      opacity: 1
    }
  }),

  requestCheckbox: (theme) => ({
    marginLeft: 0,
    height: 10
  }),

  cell: (theme) => ({
    display: 'flex',
    padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
    flex: '0 0 auto',
    lineHeight: theme.typography.body2.lineHeight,
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    border: 'none',
    borderTop: 0,
    borderBottom: 0,
    background: 'white',
    zIndex: 0,
    '&:first-of-type': {
      borderLeft: 0,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius
    },
    '&:last-of-type': {
      borderRight: 0,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius
    }
  }),

  clickableCellMargin: (theme) => ({
    // padding: `0px ${theme.spacing(1)}px !important`,
    cursor: 'default'
  }),

  feedTableRow: (theme) => ({
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden', // so the corners actually clip
    flexGrow: 1,
    zIndex: 2,
    margin: `${theme.spacing(ROW_SPACING)} 0`,
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    boxShadow: rowShadowAtRest,
    background: ROW_CELL_BACKGROUND_COLOR,
    '&.hover': {
      boxShadow: '0px 2px 8px -1px rgba(0,0,0,0.8)'
      // border: `${hoverRowBorderSize}px solid hsl(0,0%,60%)`
    },
    '&.hover td:first-of-type': {
      // borderLeft: hoverRowBorderSize, // theme.props.MuiButtonBase.outlined.border,
      borderTopLeftRadius: theme.shape.borderRadius, 
      borderBottomLeftRadius: theme.shape.borderRadius
      // borderColor: theme.palette.grey['300'],
      // borderStyle: 'solid',
      // borderTop: hoverRowBorderSize,
      // borderBottom: hoverRowBorderSize
    },
    '&.hover td': {
      // borderColor: theme.palette.grey['300'],
      // borderStyle: 'solid',
      borderLeft: 0,
      borderRight: 0
      // borderTop: hoverRowBorderSize,
      // borderBottom: hoverRowBorderSize
    },
    '&.hover td:last-of-type': {
      // borderRight: hoverRowBorderSize, // theme.props.MuiButtonBase.outlined.border,
      borderBottomRightRadius: theme.shape.borderRadius, 
      borderTopRightRadius: theme.shape.borderRadius
      // borderColor: theme.palette.grey['300'],
      // borderStyle: 'solid',
      // borderTop: hoverRowBorderSize,
      // borderBottom: hoverRowBorderSize,
    },
    '&.hover td.actionCell': {
      padding: 0,
      display: 'flex',
      marginLeft: 0,
      '& button': {
        backgroundColor: theme.palette.primary.lighter,
        // e.g. borderRadius to match shape
      },
      // backgroundColor: 'hsl(0,0%,99%)',
      '&:first-of-type': {
        borderLeft: 0, // theme.props.MuiButtonBase.outlined.border,
        borderTopLeftRadius: theme.shape.borderRadius, 
        borderBottomLeftRadius: theme.shape.borderRadius
      },
      '&.lastChild': {
        borderRight: 0, // theme.props.MuiButtonBase.outlined.border,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '& *': {
        color: 'white'
      }
    },
    '& .lastChild': {
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius
    },
    '& td.actionCell': {
      display: 'none'
    },
    '&.hover td.hideOnRowHover': {
      display: 'none'
    },
    '&.hover .hoverOpacity': {
      opacity: 1
    },
    [theme.breakpoints.down('sm')]: {
      boxShadow: rowShadowAtRest,
      borderRadius: theme.shape.borderRadius,
      '&.hover td:last-of-type': {
        borderBottomRightRadius: theme.shape.borderRadius / 2,
        borderTopRightRadius: theme.shape.borderRadius / 2
      }
    }
  }),
  rowExpanded: (theme) => ({
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    zIndex: 0,
    '&.hover': {
      boxShadow: rowShadowAtRest
    },
    '& td, & td:first-of-type, & td:last-of-type, &.hover td, &.hover td:first-of-type, &.hover td:last-of-type': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
      // backgroundColor: 'hsl(0, 0%, 99%)'
    },
    '& .lastChild': {
      borderBottomRightRadius: 0
    }
  }),
  rowCollapsed: (theme) => ({

  }),
  expandedTableRow: (theme) => ({
    width: 'auto',
    display: 'flex',
    zIndex: 1,
    transition: 'transform 0.3s ease-out',
    transform:'scaleY(1)',
    transformOrigin:'top',
    marginTop: -theme.spacing(ROW_SPACING),
    background: 'white',
    marginLeft: 0,
    marginRight: 0,
    boxShadow: '0px 2px 8px -1px rgba(0,0,0,0.2)',
    marginBottom: 0,
    borderBottom: 0,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    '& td': {
      borderBottom: 0
    },
    '&.expanded': {
      height: 'auto',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2)
    },
    '&.collapsed': {
      transform:'scaleY(0)',
      display: 'none'
    }
  }),
  rowActionBtn: (theme) => ({
    borderRadius: 0,
    height: theme.layout.listTable.rowHeight,
    width: theme.layout.listTable.rowHeight,
    minWidth: theme.layout.listTable.rowHeight,
    backgroundColor: theme.palette.primary.lighter
  }),
  simpleTableHeadRow: (theme) => ({
    height: 36
  }),
  nakedTable: (theme) => ({ // https://material-ui.com/components/tables/#simple-table

  }),
  nakedTableHeadRow: (theme) => ({
    '& th': {
      fontWeight: 700
    }
  }),
  nakedTableBodyRow: (theme) => ({
    '&:last-of-type td, &:last-of-type th': {
      borderBottom: 0
    }
  }),
  // MOBILE STYLES
  mobileFeedItem: (theme) => ({
    borderRadius: theme.shape.borderRadius / 2,
    // position: 'sticky',
    // top: theme.layout.customProps.header.height*2,
    boxShadow: rowShadowAtRest,
    height: MOBILE_ITEM_HEIGHT,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
    '&.hover': {
      boxShadow: '0px 2px 8px -1px rgba(0,0,0,0.8)'
    }
  }),
  mobileTableHeader: (theme) => ({
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
    fontSize: '0.8rem'
  }),
  mobileTileCtr: (theme) => ({
    flexWrap: 'nowrap',
    minHeight: 45,
    marginBottom: 0,
    '& p': {
      fontSize: '0.9rem'
    }
  }),
  mobileRowItem: (theme) => ({
    flexWrap: 'nowrap',
    marginTop: 0,
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  tileLeftColCtr: (theme) => ({

  }),
  tileRightColCtr: (theme) => ({

  }),
  tileTitle: (theme) => ({

  }),
  tileSubTitle: (theme) => ({
    color: 'hsl(0,0%,50%)'
  }),
  tileSmallText: (theme) => ({
    fontSize: '0.8rem'
  }),
  tileNewLine: (theme) => ({
    marginTop: theme.spacing(0.5)
  }),
  tileFooter: (theme) => ({
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5)
  }),
  tileActionBtn: (theme) => ({
    margin: theme.spacing(0.25),
    borderRadius: TILE_ACTION_BTN_WIDTH,
    height: TILE_ACTION_BTN_WIDTH,
    width: TILE_ACTION_BTN_WIDTH,
    minWidth: TILE_ACTION_BTN_WIDTH,
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    '& i, & *': {
    fontSize: '1rem'
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }),
  resultsCount: (theme) => ({
    color: '#5b5b5b',
    fontSize: '0.8rem',
    marginBottom: '1rem',
    paddingLeft: theme.spacing(1)
  })
};

export default commonListTableStyles;